import React from 'react';
import { motion } from 'framer-motion';
import { BookOpenIcon } from 'lucide-react';
const chapters = [{
  num: '01',
  title: 'La Alerta Roja',
  subtitle: "Por qué tu cuerpo está 'en llamas'",
  desc: 'Entiende la ciencia detrás de la inflamación crónica y cómo identificar las señales de auxilio de tu cuerpo antes de que se conviertan en dolor.'
}, {
  num: '02',
  title: 'El Método SOS',
  subtitle: 'Los 5 Venenos que debes soltar HOY',
  desc: 'La lista exacta de alimentos y hábitos que debes eliminar inmediatamente para detener la hinchazón diaria.'
}, {
  num: '03',
  title: 'Reparación de Emergencia',
  subtitle: 'Tu Plan de 48 Horas',
  desc: 'El protocolo paso a paso para tus primeros dos días. Qué comer, qué beber y cómo moverte para ver resultados rápidos.'
}, {
  num: '04',
  title: 'El Escudo Anti-Inflamatorio',
  subtitle: 'Mantenimiento 45+',
  desc: 'Cómo reintroducir alimentos de forma segura y mantener un estilo de vida desinflamado a largo plazo sin dietas restrictivas.'
}];
export function ChaptersInside() {
  return <section className="py-24 bg-cream relative" data-id="element-33">
      <div className="container mx-auto px-6 max-w-5xl" data-id="element-34">
        <motion.div className="text-center mb-16" initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-35">
          <div className="flex justify-center mb-4" data-id="element-36">
            <BookOpenIcon className="text-sage w-10 h-10" data-id="element-37" />
          </div>
          <h2 className="text-4xl md:text-5xl font-serif mb-6" data-id="element-38">
            Qué encontrarás dentro
          </h2>
          <p className="text-lg text-charcoal/70 max-w-2xl mx-auto" data-id="element-39">
            Un manual directo y al grano, diseñado para leerse rápido y
            aplicarse de inmediato.
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-40">
          {chapters.map((chapter, index) => <motion.div key={index} className="bg-white p-8 rounded-2xl shadow-sm border border-sage/10 hover:border-sage/30 transition-colors duration-300" initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} data-id="element-41">
              <div className="text-sage font-serif text-5xl opacity-30 mb-4 leading-none" data-id="element-42">
                Cap. {chapter.num}
              </div>
              <h3 className="text-2xl font-serif font-semibold mb-1" data-id="element-43">
                {chapter.title}
              </h3>
              <h4 className="text-sage font-medium mb-4" data-id="element-44">{chapter.subtitle}</h4>
              <p className="text-charcoal/70 leading-relaxed" data-id="element-45">{chapter.desc}</p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}